import type { FC } from "react";
import { motion } from "motion/react";
import { cn } from "utils";
import {
  INTRO_SLIDE_COUNT,
  SIGN_IN_INTRO_CAROUSEL_INTERVAL_MS,
} from "./introSlidesConfig";
import { usePrefersReducedMotion } from "./usePrefersReducedMotion";

interface IntroSegmentProgressProps {
  activeIndex: number;
  className?: string;
}

export const IntroSegmentProgress: FC<IntroSegmentProgressProps> = ({
  activeIndex,
  className,
}) => {
  const reducedMotion = usePrefersReducedMotion();

  return (
    <div
      className={cn("flex w-full gap-1", className)}
      data-testid="intro-segment-progress"
      aria-label={`Intro slide ${activeIndex + 1} of ${INTRO_SLIDE_COUNT}`}
    >
      {Array.from({ length: INTRO_SLIDE_COUNT }, (_, index) => {
        const isComplete = index < activeIndex;
        const isActive = index === activeIndex;

        return (
          <div
            key={index}
            className="relative h-1.5 min-w-0 flex-1 overflow-hidden rounded-full bg-background_white_overlay20"
          >
            {isComplete ? (
              <div className="absolute inset-0 rounded-full bg-content_aura_lv3_primary" />
            ) : null}
            {isActive ? (
              <motion.div
                className="absolute inset-y-0 left-0 rounded-full bg-content_aura_lv3_primary"
                initial={reducedMotion ? { width: "100%" } : { width: "0%" }}
                animate={{ width: "100%" }}
                transition={
                  reducedMotion
                    ? { duration: 0 }
                    : {
                        // Figma Progress fill (active) — linear across dwell
                        duration: SIGN_IN_INTRO_CAROUSEL_INTERVAL_MS / 1000,
                        ease: "linear",
                      }
                }
              />
            ) : null}
          </div>
        );
      })}
    </div>
  );
};
